import { render } from "./Layout.vue?vue&type=template&id=ecbae878&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=ecbae878&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ecbae878"

export default script